import { PayloadAction } from '@reduxjs/toolkit';
import { put } from 'redux-saga/effects';
import { eventBus } from 'utils/eventBus';
import { logger } from 'utils/logger';
import { PrejoinResponse } from 'features/room/types';
import { joinScreenEnabledChanged } from 'features/room/roomSlice';
import { toolbarVisibilityChanged } from 'features/toolbar/toolbarSlice';
import { layoutModeChanged } from 'features/layout/features/config/configSlice';
import { joinDefaultsChanged } from 'features/user-media/userMediaSlice';

// Must stay non-suspending — put only, no take/call. takeLatest runs this to completion within
// one channel notification, so join defaults land before room status can reach 'join'.
export function* prepareRoomDefaultsSaga(action: PayloadAction<PrejoinResponse>) {
  const { settings, media } = action.payload;
  const init = eventBus.initState;

  const audio = init.audioEnabled ?? media.audio;
  const video = init.videoEnabled ?? media.video;

  logger.remote().info(`Video ${video ? 'enabled' : 'disabled'} by default`);
  logger.remote().info(`Audio ${audio ? 'enabled' : 'disabled'} by default`);

  yield put(joinScreenEnabledChanged(init.joinScreenEnabled ?? settings.joinScreenEnabled));
  yield put(toolbarVisibilityChanged(init.showToolbar ?? settings.toolbarEnabled));
  yield put(layoutModeChanged(init.layoutMode ?? settings.layoutModeOnJoin));
  yield put(joinDefaultsChanged({ audio, video }));
}
